import styled from "styled-components";

export const FullWrap = styled.div`
    margin-top: 7.5rem;
    display: flex;
    @media  only screen and (max-width:991px){
         margin-top: 20px;
    }
`;

export const RightWrap = styled.div`
    margin-left: 17.5rem;
    width: 100%;
    padding: 15px;
    @media  only screen and (max-width:991px){
        margin-left:0rem;
    }
`;

export const TableWrap = styled.div`
    .rt-resizable-header{
        padding: 14px 10px !important;
        font-size: 14px;
        text-align: left;
        font-weight: 700;
        color: #3c4858;
        display: block;
        border-top: 1px solid #c0ccda;
        border-bottom: 1px solid #c0ccda;
        border-right: 1px solid #c0ccda !important;
    }
    .ReactTable{
        border: 1px solid #c0ccda;
    }
    .rt-tbody .rt-td{
        background-color: #fff;
        padding: 14px 10px !important;
        font-weight: 400;
        font-size: 13px;
    }
    .action-button{
        background-color: transparent !important;
        border: 1px solid gray !important;
        border-radius: 50%;
        color: #8cc63f !important;
        display: flex;
        align-items: center;
        height: 35px;
        width: 35px;
        justify-content: center;
        margin: 0px 5px !important;
    }
`;

export const Loader = styled.div`

    background: #000000b0;
    position: fixed;
    left: 0;
    top: 0;
    z-index: 9999;
    display: flex;
    width: 100%;
    align-items: center;
    height: 100%;
    justify-content: center;
    .spinner-border {
        color: #8cc63f
    }
`;


// WEBPACK FOOTER //
// ./src/views/Landing/styles.js